import { Controller } from "@hotwired/stimulus"

// 정산 일괄 작업 컨트롤러
export default class extends Controller {
  static targets = ["checkbox", "selectAll", "bulkActions", "selectedCount"]

  connect() {
    this.updateUI()
  }

  toggleAll(event) {
    const checked = event.target.checked
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = checked
    })
    this.updateUI()
  }

  toggleOne() {
    this.updateUI()
  }

  updateUI() {
    const checkedCount = this.getCheckedIds().length
    const totalCount = this.checkboxTargets.length

    // 전체 선택 체크박스 상태 업데이트
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = checkedCount === totalCount && totalCount > 0
      this.selectAllTarget.indeterminate = checkedCount > 0 && checkedCount < totalCount
    }

    // 일괄 작업 버튼 표시/숨김
    if (this.hasBulkActionsTarget) {
      if (checkedCount > 0) {
        this.bulkActionsTarget.classList.remove('hidden')
      } else {
        this.bulkActionsTarget.classList.add('hidden')
      }
    }

    // 선택된 개수 표시
    if (this.hasSelectedCountTarget) {
      this.selectedCountTarget.textContent = checkedCount
    }
  }

  getCheckedIds() {
    return this.checkboxTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value)
  }

  bulkConfirm(event) {
    event.preventDefault()
    const ids = this.getCheckedIds()

    if (ids.length === 0) {
      alert('선택된 정산이 없습니다.')
      return
    }

    if (!confirm(`${ids.length}건의 정산을 확정하시겠습니까?`)) {
      return
    }

    this.submitBulkAction('/admin/settlements/bulk_confirm', ids)
  }

  bulkMarkPaid(event) {
    event.preventDefault()
    const ids = this.getCheckedIds()

    if (ids.length === 0) {
      alert('선택된 정산이 없습니다.')
      return
    }

    if (!confirm(`${ids.length}건의 정산을 지급완료 처리하시겠습니까?`)) {
      return
    }

    this.submitBulkAction('/admin/settlements/bulk_mark_paid', ids)
  }

  submitBulkAction(url, ids) {
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = url

    // CSRF 토큰 추가
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    if (csrfToken) {
      const csrfInput = document.createElement('input')
      csrfInput.type = 'hidden'
      csrfInput.name = 'authenticity_token'
      csrfInput.value = csrfToken
      form.appendChild(csrfInput)
    }

    // ID 배열 추가
    ids.forEach(id => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = 'ids[]'
      input.value = id
      form.appendChild(input)
    })

    document.body.appendChild(form)
    form.submit()
  }

  exportExcel(event) {
    event.preventDefault()
    const ids = this.getCheckedIds()

    if (ids.length === 0) {
      alert('선택된 정산이 없습니다.')
      return
    }

    // 엑셀 다운로드 URL 생성
    const url = new URL('/admin/settlements/export_xlsx', window.location.origin)
    ids.forEach(id => url.searchParams.append('ids[]', id))

    window.location.href = url.toString()
  }
}
